import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_LABTYPE,
  DELETE_LABTYPE,
  GET_LABTYPES,
  UPDATE_LABTYPE,
  UPDATE_LABTYPE_STATUS
} from "./actionTypes";

import {
  addLabTypeFail,
  addLabTypeSuccess,
  deleteLabTypeFail,
  deleteLabTypeSuccess,
  getLabTypesFail,
  getLabTypesSuccess,
  setState,
  updateLabTypeFail,
  updateLabTypeSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { labTypes, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchLabTypes({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, labTypes, params.toString());
    yield put(setState(false));
    yield put(getLabTypesSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getLabTypesFail(error));
  }
}

function* updateLabType({ payload: labtypeObj }) {
  try {
    const { id, recordStatus, ...rest } = labtypeObj;
    yield call(patchApiCall, `${labTypes}/${id}`, rest);
    const response = yield call(getTable, `${labTypes}/${labtypeObj.id}`);
    toast.success('Registro actualizado correctamente');
    yield put(updateLabTypeSuccess(response));
  } catch (error) {
    yield put(updateLabTypeFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateLabTypeStatus({ payload: labtypeObj }) {
  try {
    const { id } = labtypeObj;
    yield call(patchApiCall, `${labTypes}/${updateStatus}/${id}`, { recordStatus: labtypeObj.recordStatus });
    const response = yield call(getTable, `${labTypes}/${labtypeObj.id}`);
    yield put(updateLabTypeSuccess(response));
  } catch (error) {
    yield put(updateLabTypeFail(error));
  }
}

function* deleteLabType({ payload: labtypeObj }) {
  try {
    yield call(deleteApiCall, `${labTypes}/${labtypeObj.id}`);
    yield put(deleteLabTypeSuccess(labtypeObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteLabTypeFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingLabType({ payload: labType }) {
  try {
    const response = yield call(postApiCall, labTypes, labType);
    yield put(addLabTypeSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addLabTypeFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* labsTypesSaga() {
  yield takeEvery(GET_LABTYPES, fetchLabTypes);
  yield takeEvery(ADD_NEW_LABTYPE, postingLabType);
  yield takeEvery(UPDATE_LABTYPE, updateLabType);
  yield takeEvery(UPDATE_LABTYPE_STATUS, updateLabTypeStatus);
  yield takeEvery(DELETE_LABTYPE, deleteLabType);
}

export default labsTypesSaga;
